import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { CompanyOfferService, CompanyOfferV2Model } from '@fgb/core';

@Component({
  selector: 'fgb-partner-offers-list',
  templateUrl: './partner-offers-list.component.html',
  styleUrls: ['./partner-offers-list.component.scss'],
})
export class PartnerOffersListComponent implements OnInit {
  offers$: Observable<CompanyOfferV2Model[]>;

  constructor(private companyOfferService: CompanyOfferService) {}

  ngOnInit() {
    this.offers$ = this.companyOfferService.fetchOffersV2(0, 0);
  }
}
